import { longtailBookingsActionTypes as actions } from '~client/constants/actionTypes';
import { fetch } from '~actions/shared';
import * as queries from '~settings/queries';
import endpoints from '~settings/endpoints';
import { formatSimpleParams } from '~helpers';
import { message } from 'antd';
import i18n from '~settings/i18n';

export const setLongtailBookings = payload => ({
  type: actions.SET_LONG_TAIL_BOOKINGS,
  payload,
});

export const getLongtailBookings =
  (params, onSuccess = () => {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.GET_LONG_TAIL_BOOKINGS_CS,
      params: queries.getLongtailBookings(
        formatSimpleParams(
          {
            pageNumber: 1,
            pageSize: 10,
            sortBy: 'UPDATED_AT',
            sortDirection: 'DESCENDING',
            stages: null,
            referenceId: null,
            passportFullName: null,
            studentEmail: null,
            propertyNodeId: null,
          },
          params,
        ),
      ),
      dispatch,
      successAction: setLongtailBookings,
      onSuccess: res => {
        onSuccess(res);
      },
    });
  };

export const confirmOrder =
  (id, onSuccess = () => {}, onError = () => {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.CONFIRM_ORDER_CS,
      params: queries.confirmOrder({ id }),
      dispatch,
      onSuccess: () => {
        onSuccess();
        message.success(i18n.t('landlord.payment.long_tail.accept_booking.success.tips'));
      },
      onError: (e, code) => {
        if ((e && e.length > 0 && e[0].message) || code) {
          if (
            e[0].message.indexOf('NON_CONFIRMATION_IN_TIME') !== -1 ||
            code.indexOf('NON_CONFIRMATION_IN_TIME') !== -1
          ) {
            onError();
            message.error(i18n.t('landlord.payment.long_tail.order.not_confirmed_error.tips'));
          } else if (
            e[0].message.indexOf('INVALID_STAGE') !== -1 ||
            code.indexOf('INVALID_STAGE') !== -1
          ) {
            onError();
            message.error(i18n.t('landlord.payment.long_tail.order.confirm_invalid_stage.tips'));
          } else {
            message.error(i18n.t('landlord.error.default'));
          }
        } else {
          message.error(i18n.t('landlord.error.default'));
        }
      },
    });
  };

export const rejectOrder =
  (id, rejectedReason, onSuccess = () => {}, onError = () => {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.REJECT_ORDER_CS,
      params: queries.rejectOrder({ id, rejectedReason }),
      dispatch,
      onSuccess: () => {
        onSuccess();
        message.success(i18n.t('landlord.payment.long_tail.reject_booking.success.tips'));
      },
      onError: (e, code) => {
        if ((e && e.length > 0 && e[0].message) || code) {
          if (
            e[0].message.indexOf('NON_CONFIRMATION_IN_TIME') !== -1 ||
            code.indexOf('NON_CONFIRMATION_IN_TIME') !== -1
          ) {
            onError();
            message.error(i18n.t('landlord.payment.long_tail.order.not_rejected_error.tips'));
          } else if (
            e[0].message.indexOf('INVALID_STAGE') !== -1 ||
            code.indexOf('INVALID_STAGE') !== -1
          ) {
            onError();
            message.error(i18n.t('landlord.payment.long_tail.order.reject_invalid_stage.tips'));
          } else {
            message.error(i18n.t('landlord.error.default'));
          }
        } else {
          message.error(i18n.t('landlord.error.default'));
        }
      },
    });
  };

export const confirmRefund =
  (id, onSuccess = () => {}, onError = () => {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.REJECT_REFUND_CS,
      params: queries.confirmRefund({ id }),
      dispatch,
      onSuccess: () => {
        onSuccess();
      },
      onError: (e, code) => {
        onError();
        if ((e && e.length > 0 && e[0].message) || code) {
          if (
            e[0].message.indexOf('ORDER_REFUND_STATUS_ERROR') !== -1 ||
            code.indexOf('ORDER_REFUND_STATUS_ERROR') !== -1
          ) {
            onError();
            message.error(i18n.t('landlord.payment.long_tail.order.confim_refund_error.tips'));
          } else {
            message.error(i18n.t('landlord.error.default'));
          }
        } else {
          message.error(i18n.t('landlord.error.default'));
        }
      },
    });
  };
